const en = {
  translation: {
    nav: {
      brand: 'IELTS Speaking AI',
      dashboard: 'Dashboard',
      logout: 'Logout',
      admin: 'Admin',
    },
    auth: {
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      name: 'Name',
      forgotPassword: 'Forgot password?',
      noAccount: 'No account?',
      hasAccount: 'Have an account?',
      verifyTitle: 'Verify Email',
      verifyDesc: 'A 6-digit code was sent to',
      codePlaceholder: '123456',
      confirm: 'Confirm',
      resendCode: 'Resend code',
      resetTitle: 'Reset Password',
      resetDesc: 'Enter your email and we\'ll send a code',
      newPassword: 'New password',
      updatePassword: 'Update password',
      sendCode: 'Send code',
      back: '← Back',
      backToLogin: '← Back to login',
      loggingIn: 'Logging in...',
      registering: 'Registering...',
      sending: 'Sending...',
      checking: 'Checking...',
      saving: 'Saving...',
      continue: 'Continue',
    },
    dashboard: {
      welcome: 'Welcome',
      subtitle: 'Continue preparing for your IELTS Speaking exam.',
      level: 'Level',
      totalXp: 'Total XP',
      streak: 'Daily streak',
      longestStreak: 'Best',
      avgScore: 'Avg. score',
      sessions: 'sessions',
      dailyLimit: 'Daily limit',
      resetsAt: 'Resets every day at 00:00',
      remaining: 'remaining',
      used: 'used',
      limitDone: 'Done',
      startBtn: 'Start →',
      vocabTitle: 'Topic Vocabulary',
      vocabDesc: 'Enter any topic and get IELTS-relevant vocabulary with definitions and examples.',
      speakingTitle: 'Speaking Practice',
      speakingDesc: 'Choose Part 1, 2 or 3. Practice with an AI examiner in real time.',
      leaderboard: 'Leaderboard',
      today: 'Today',
      week: 'Week',
      noLeaderboard: 'No one has practiced yet',
      recentSessions: 'Recent sessions',
      noSessions: 'No sessions yet. Start your first one!',
      tabHome: '🏠 Home',
      tabProgress: '📈 Progress',
      tabExam: '🎓 Mock Exam',
      youLabel: 'you',
      premiumUnlimited: 'Premium — Unlimited access',
      premiumExpires: 'Premium expires',
      daysLeft: 'days left',
    },
    speaking: {
      title: 'Speaking Practice',
      subtitle: 'Which part would you like to practice?',
      selectTopic: 'Select a topic',
      completed: 'completed',
      sessionTitle: 'Speaking Session',
      questions: 'questions',
      startBtn: '🚀 Start Practice',
      stopBtn: '⏹ End session',
      nextBtn: '➡️ Next question',
      finishBtn: '✅ Finish session',
      retryBtn: '🔄 Try again',
      repeatBtn: 'Repeat question',
      speakBtn: '🎤 Speak',
      stopListenBtn: '⏹ Stop & Get Feedback',
      listening: 'Listening... Speak now!',
      pressToSpeak: 'Press the mic button and speak',
      aiAnalyzing: 'AI is analyzing your answer...',
      yourAnswer: 'Your answer',
      aiExaminer: 'AI Examiner',
      speaking: '🔊 Speaking...',
      feedbackTitle: '📝 AI Feedback',
      score: 'Score',
      improvedVersion: '✨ Improved Version (Band 7-8)',
      sessionEnded: '🏆 Session ended!',
      answeredAll: 'questions answered. Well done!',
      chooseTopic: 'Choose another topic',
      sessionResults: '📋 Session results',
      previousQuestions: '📋 Previous questions',
      part2prep: '📝 Preparation time',
      part2speak: '🎤 Speaking time',
      part2prepNote: 'Make notes. Timer will switch automatically.',
      part2info: 'Part 2 — Timer mode',
      part2min1: '1 minute preparation',
      part2min2: '2 minutes to speak',
      part2auto: 'Timer switches automatically',
      preparation: 'Preparation',
      chromeTip: 'Use Chrome or Edge browser',
      micTip: 'Allow microphone access',
      quietTip: 'Be in a quiet environment',
      questionList: 'Questions',
      back: '← Back',
      savedSession: 'Session saved!',
      avgScoreLabel: 'Avg. score',
      xpEarned: 'XP earned',
      streakLabel: 'Daily streak',
      continueBtn: 'Continue',
      fluency: 'Fluency',
      vocabulary: 'Vocabulary',
      grammar: 'Grammar',
      pronunciation: 'Pronunciation',
      yourAnswerLabel: 'Your answer',
      improvedLabel: 'Improved',
    },
    mockExam: {
  title: '🎓 Mock IELTS Speaking',
  subtitle: 'Full exam simulation — random topics',
  startBtn: '🚀 Start Exam',
  preparing: 'Preparing questions...',
  randomNote: '🎲 Random topics selected every time — just like the real exam',
  weeklyLimit: 'Weekly limit reached',
  getPremium: '👑 View Premium',
  partBreak: 'completed!',
  starting: 'starting...',
  topic: 'Topic',
  cancelBtn: '⏹ End Exam',
  cancelConfirm: 'End the exam early? Result won\'t be saved.',
  resultTitle: 'Exam finished!',
  bandScore: 'Your IELTS Band Score:',
  retake: '🔄 Retake',
  toDashboard: 'Dashboard →',
  analyzeMsg: 'AI is analyzing...',
  retry: '🔄 Retry',
  next: '➡️ Next question',
  finishPart: 'go to Part',
  finishExam: '🏁 Finish exam',
  history: 'Previous exams',
  noHistory: 'No exams yet. Start your first one!',
  xpEarned: 'XP earned',
},
progress: {
  title: 'Weekly progress',
  goalTitle: '🎯 Target Band Score',
  change: 'Change',
  cancel: 'Cancel',
  highGoal: '🌟 High goal! Lots of practice needed',
  realisticGoal: '✅ Realistic goal!',
  startGoal: 'Starting goal, can raise it later',
  currentScore: 'Current score',
  goalReached: '✅ Goal reached!',
  remaining: 'to go',
  consistency: 'Consistency',
  weeklySessions: 'Weekly sessions',
  forecast: '🔮 Forecast',
  forecastNote: 'Realistic = current pace · Optimal = daily practice',
  goalTarget: 'Target',
  realistic: 'Realistic',
  optimal: 'Optimal',
  goalReachedLabel: '🎯 Goal!',
  tip: '💡 Tip',
  lastSession: 'Last practice',
  daysAgo: 'days ago',
  totalSessions: 'sessions analyzed',
  needMore: 'Need at least 3 sessions for the chart.',
  goalSaved: 'Goal saved above.',
  targetLine: 'Target',
},
premium: {
  title: 'Premium',
  subtitle: 'Practice without limits',
  activeTitle: 'You are a Premium user!',
  daysLeft: 'days left',
  allOpen: 'All features unlocked ✓',
  backDashboard: 'Go to Dashboard',
  feature: 'Feature',
  free: 'Free',
  popular: 'Popular',
  selectedPlan: 'Selected plan',
  howToPay: 'How to pay:',
  step1: '1. Click the Telegram button',
  step2: '2. Send your plan name and user ID',
  step3: '3. Complete the payment',
  step4: '4. Admin grants Premium within 24h',
  yourId: 'Your User ID (send to admin):',
  copy: 'Copy',
  copied: '✓',
  telegramBtn: 'Message on Telegram',
  note: 'Access granted within 24 hours after payment',
  back: '← Back',
  sum: 'UZS',
},
    vocab: {
      title: '📚 Topic Vocabulary',
      placeholder: 'Enter a topic... (e.g. Technology, Education, Travel)',
      searchBtn: '🔍 Search',
      searching: '⏳ Searching...',
      resultsFor: 'vocabulary for',
      definition: 'Definition',
      example: 'Example',
      error: 'Error fetching vocabulary. Please try again.',
      limitError: 'Daily limit reached! 7 searches per day. Try again tomorrow.',
    },
    common: {
      loading: 'Loading...',
      back: '← Back',
      question: 'Question',
      answer: 'Answer',
    },
  },
};
export default en;